import React, { useContext } from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import reduce from 'lodash/reduce';

import StoreContext from '../context/StoreContext';
import cavanLogo from '../assets/cavan-logo.png';

const useQuantity = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext);
  const items = checkout ? checkout.lineItems : [];
  const total = reduce(items, (acc, item) => acc + item.quantity, 0);
  return [total !== 0, total];
};

const Header = ({ selected }) => {
  const [hasItems, quantity] = useQuantity();
  return (
    <Container>
      <Top>
        <Left>
          <Link to="/">
            <Image src={cavanLogo} />
          </Link>
        </Left>
        <Nav>
          <NavLink to="/" selected={selected === '/'}>
            Shop
          </NavLink>
          <NavLink to="/subscription" selected={selected === '/subscription'}>
            Subscription
          </NavLink>
          <NavLink to="/cafe" selected={selected === '/cafe'}>
            Who We Are
          </NavLink>
          <NavLink to="/locations" selected={selected === '/locations'}>
            Where We Are
          </NavLink>
          <NavLink to="/cart" selected={selected === '/cart'}>
            Cart
            {hasItems && (
              <span style={{ color: 'red', marginLeft: '8px' }}>
                ({quantity})
              </span>
            )}
          </NavLink>
        </Nav>
      </Top>
    </Container>
  );
};

const Container = styled.div`
  background-color: black;
  border-bottom: 6px solid red;
  display: flex;
  ${'' /* flex-direction: column; */}
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  z-index: 999;
`;

const Hours = styled.div`
  text-transform: uppercase;
  color: white;
  width: 200px;
  margin-left: 24px;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.25;
  span {
    float: right;
  }
  @media (max-width: 750px) {
    display: none;
  }
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  a {
    text-decoration: none;
    border-bottom: none;
    display: inherit;
  }
`;

const Top = styled.div`
  height: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: white;
  max-width: 1000px;
  flex-grow: 1;
  @media (max-width: 1048px) {
    padding: 0 24px;
  }
  @media (max-width: 600px) {
    justify-content: center;
    flex-direction: column;
  }
`;

const Image = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 0px;
  padding: 0;
  @media (max-width: 600px) {
    width: 50px;
    height: 50px;
  }
  @media (max-width: 380px) {
    width: 30px;
    height: 30px;
  }
`;

const Nav = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const NavLink = styled(Link)`
  color: white;
  margin-left: 24px;
  border-bottom: 2px solid black;
  font-family: Inter;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 12px;
  white-space: nowrap;
  ${props =>
    props.selected
      ? `
    color: red;
    border-bottom: 2px solid red;`
      : null}
  @media (max-width: 600px) {
    margin: 2px 8px;
  }
`;

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
